import {shopModule} from '../module.js';
import {SolrQueryService} from "@nuskin/ns-shop";

shopModule.service('solrQueryService', [function () {

    //---------------------------------------------------------------------------
    //
    //                           Public Methods
    //
    //---------------------------------------------------------------------------

    /**
     * Find all products that have a field that matches the searchTerm. If the search term doesn't contain any wild
     * characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products, base products, and variant products.
     */
    this.getAllProductsBySearchTerm = function(searchTerm, language, market, rows, start){
        return SolrQueryService.getAllProductsBySearchTerm(searchTerm, language, market, rows, start);
    };

    /**
     * Find all products that have a field that matches the searchTerm. If the search term doesn't contain any wild
     * characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products and base products. Variant products are excluded.
     */
    this.getProductsAndBasesBySearchTerm = function(searchTerm, language, market, rows, start){
        return SolrQueryService.getProductsAndBasesBySearchTerm(searchTerm, language, market, rows, start);
    };

    /**
     * Find all products that have a field that matches the searchTerm. If the search term doesn't contain any wild
     * characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products and variant products. Base products are excluded.
     */
    this.getProductsAndVariantsBySearchTerm = function(searchTerm, language, market, rows, start){
        return SolrQueryService.getProductsAndVariantsBySearchTerm(searchTerm, language, market, rows, start);
    };

    /**
     * Find all products that have a category field that matches the searchTerm. If the search term doesn't contain any wild
     * characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products, base products, and variant products.
     */
    this.getAllProductsByCategory = function(searchTerm, language, market, rows, start) {
        return SolrQueryService.getAllProductsByCategory(searchTerm, language, market, rows, start);
    };

    /**
     * Find all products that have a category field that matches the searchTerm. If the search term doesn't contain any wild
     * characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products and base products. Variant products are excluded.
     */
    this.getProductsAndBasesByCategory = function(searchTerm, language, market, rows, start) {
        return SolrQueryService.getProductsAndBasesByCategory(searchTerm, language, market, rows, start);
    };

    /**
     * Find all products that have a category field that matches the searchTerm. If the search term doesn't contain any wild
     * characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products and variant products. Base products are excluded.
     */
    this.getProductsAndVariantsByCategory = function(searchTerm, language, market, rows, start) {
        return SolrQueryService.getProductsAndVariantsByCategory(searchTerm, language, market, rows, start);
    };

    /**
     * Find all products that match SKUs passed in the searchTerm.
     *
     * @param skuArray - Examples: 01003049, 01003061 etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     *
     * @returns A promise to the result which may contain general products and variant products. Base products are excluded.
     */
    this.getProductsBySKUArray = function(skuArray, language, market) {
        return SolrQueryService.getProductsBySKUArray(skuArray, language, market);
    };

    /**
     * Find products and base products that have a field that matches the searchTerm. If the search term doesn't
     * contain any wild characters we will be search for an exact match for the value of searchTerm.while fetching
     * the results giving more weight to ProductTitle field.
     * Solr query used eDisMax parser.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products and base products. Variant products are excluded.
     */
    this.getProductsAndBasesBySearchTermWithFieldLevelBoosting= function(searchTerm, language, market, rows, start) {
        return SolrQueryService.getProductsAndBasesBySearchTermWithFieldLevelBoosting(searchTerm, language, market, rows, start);
    };
    /**
     * Find products and variant products that have a field that matches the searchTerm. If the search term doesn't
     * contain any wild characters we will be search for an exact match for the value of searchTerm.
     *
     * @param searchTerm - Examples: Age, Age*, *Age*, etc.
     * @param language - Example: "en"
     * @param market   - Example: "US"
     * @param rows - Number of results to return
     * @param start - Used for pagination.
     *
     * @returns A promise to the result which may contain general products and variant products. Base products are excluded.
     */
    this.getProductsAndVariantsBySearchTermWithFieldLevelBoosting= function(searchTerm, language, market, rows, start){
        return SolrQueryService.getProductsAndVariantsBySearchTermWithFieldLevelBoosting(searchTerm, language, market, rows, start);
    };
}]);
